import { EditIcon } from '@chakra-ui/icons';

export const columnsDataClients = [
  {
    Header: "Nombre",
    accessor: "name",
  },
  {
    Header: "RUT",
    accessor: "rut",
  },
  {
    Header: "Teléfono",
    accessor: "phone",
  },
  {
    Header: "Mail",
    accessor: "email",
  },
  {
    Header: "Dirección",
    accessor: "address",
  },
  {
    Header: '',
    accessor: 'actions',
    actions: [
      {
        label: 'Editar',
        icon: <EditIcon />,
        colorScheme: 'blue',
        type: 'edit'
      },
    ]
  }
];
